export const EsemenyJelleg = Object.freeze({
  Nyilt: 203,
  Zart: 204,
});
